export default function MySQL_USER() {
  return (
    <div>
      <h2>MySQL_USER</h2>    </div>
  );
}